/* eslint-disable */
// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core'
import React, { useContext, useState, useEffect, useRef } from 'react'
import { Query } from 'react-apollo'
import moment from 'moment';
import type { GridItem } from '../../../types'
import GridApi from '../../../components/GridApi'
import Curtain from '../../../components/Curtain'
import ActionsHeader from '../../../components/ActionsHeader'
import ModuleQuery from '../../../components/ModuleQuery'
import Row from '../../../components/Row'
import Col from '../../../components/Col'
import ContentChecker from '../../../components/ContentChecker'
import BlockingStatus from '../../../components/BlockingStatus'
import GridApiController from '../../../controllers/GridApiController'
import userSettingsQuery from '../../../graphql/queries/userSettings.query'
import savedOrdersMobileQuery from '../../../graphql/queries/savedOrdersMobile.query';
import ActionsOrganizer from './ActionsOrganizer';
import messages from '../../../config/messages'
import formatters from '../formatters'
import { calculateItemPrice, getDefaultUserSettings } from '../../../utils'
import { ActionsContext } from '../../../context/actions.context';
import colors from '../../../config/colors';
import { HistoryContext } from '../../../context/history.context';
import { MobileView, useMobileMediaQuery } from '../../../config/mediaQuery';
import ModuleMenuBar from '../../../components/ModuleMenuBar';

type Props = {
  isFullPage?: boolean,
  selectedRow?: GridItem,
  showGroupPanel?: boolean,
  paginated?: boolean,
  active: boolean,
}

const App = (props: Props) => {
  const moduleName = 'savedOrdersMobile';
  let refreshContent;

  const menuRef = useRef();
  const menuButtonRef = useRef();

  const {
    isFullPage = true,
    showGroupPanel = false,
    paginated = true,
    active = true,
  } = props;

  const actions = useContext(ActionsContext);
  const history = useContext(HistoryContext);
  const isMobile = useMobileMediaQuery();
  const [displayMenu, setDisplayMenu] = useState(false);
  const [displayRowMenu, setDisplayRowMenu] = useState(false);
  const [aggregateTotal, setAggregateTotal] = useState({});
  const [ordersIds, setOrdersIds] = useState([]);
  const [orderButtonRefs, setOrderButtonRefs] = useState();
  const [menuRefs, setMenuRefs] = useState();

  let itemHistory = null;

  const setItemHistory = (item) => {
    itemHistory = item;
  }

  const grandTotalRowCustomContent = (item: GridItem) =>
    calculateItemPrice(item)

  const changeDisplayMenu = (status) => {
    if (displayRowMenu) setDisplayRowMenu({});
    setDisplayMenu(status);
  }

  const changeDisplayRowMenu = (status, id) => {
    if (displayMenu) setDisplayMenu(false);
    setDisplayRowMenu({ [id]: status });
  }
  // TODO: In case we need to add aggregateTotal from GridApi to the saved Orders 
  // const setAggregateTotalFun = (total, itemId) => {
  //   // if (itemId && !aggregateTotal[itemId]) {
  //   // setAggregateTotal({ [itemId]: total })
  //   // }
  // }

  // used to create ref for the menu button on each individual order
  useEffect(() => {
    const menuButtonRefs = {};
    const menuRefs = {};
    ordersIds.forEach((item) => {
      menuButtonRefs[item] = React.createRef(null);
      menuRefs[item] = React.createRef(null);
    })
    setOrderButtonRefs(menuButtonRefs);
    setMenuRefs(menuRefs);
  }, [ordersIds])

  useEffect(() => {
    let handler = (e) => {
      // checking if any of the individual order menus has been clicked
      let orderMenuButtonClicked = false;
      setOrderButtonRefs(ref => {
        for (const property in ref) {
          if (!orderMenuButtonClicked) {
            orderMenuButtonClicked = ref[property].current.contains(e.target);
          }
        }
        return ref;
      })
      // checking if any of the individual menus has been clicked
      let menuClicked = false;
      setMenuRefs(ref => {
        for (const property in ref) {
          if (!menuClicked) {
            menuClicked = ref[property].current.contains(e.target);
          }
        }
        return ref;
      })

      const regularMenuButtonClicked = menuButtonRef.current && menuButtonRef.current.contains(e.target);
      if (!orderMenuButtonClicked && !menuClicked && !regularMenuButtonClicked) {
        const modal = document.getElementsByClassName('modal')[0];
        const modalOpen = modal && modal.classList.contains('in');
        if (!modalOpen) {
          setDisplayMenu(value => {
            if (value) {
              return false;
            }
            return value;
          });
          // this causes re-render issues which freezes the UI so im only updating the state if there is one menu open
          setDisplayRowMenu((value) => {
            let newValue = { ...value }
            let isOneMenuOpen = false;
            for (const property in newValue) {
              if (newValue[property] === true) {
                newValue[property] = false;
                isOneMenuOpen = true;
              }
            }
            return isOneMenuOpen ? newValue : value;
          });
        }
      }
    };
    isMobile && document.addEventListener("touchstart", handler);


    return () => {
      isMobile && document.removeEventListener("touchstart", handler);
    }
  }, []);

  return (
    <div style={{ height: 'calc(100% - 100px)', overflow: 'scroll' }}>
      <ModuleQuery
        query={savedOrdersMobileQuery}
        variables={{
          moduleName: moduleName,
        }}
      >
        {({
          data: savedModuleData,
          loading: savedModuleLoading,
          refetch: savedModuleRefetch,
          refetching: savedModuleRefetching,
          refetched: savedModuleRefetched,
        }) => (
          <Query
            query={userSettingsQuery}
            variables={{
              moduleName: moduleName,
            }}
          >
            {({ data: dataGrid, loading }: any) => {
              if (!dataGrid || loading || !savedModuleData || savedModuleLoading) {
                return (
                  <BlockingStatus
                    excludeHeader
                    active
                    container={document.body}
                    text="Loading..."
                  />
                )
              }
              const hasSavedOrders = savedModuleData &&
                savedModuleData.savedOrdersMobile &&
                savedModuleData.savedOrdersMobile.length;
              const userSettings =
                dataGrid && dataGrid.userSettings
                  ? {
                    columnsMapping: dataGrid.defaultColumns,
                    frozenColumns: dataGrid.userSettings.frozenColumns,
                    groups: dataGrid.userSettings.groups,
                    sorting: dataGrid.userSettings.sorting,
                  }
                  : {}

              const defaultUserSettings = getDefaultUserSettings(dataGrid)

              if (typeof refreshContent !== 'function') {
                refreshContent = savedModuleRefetch
              }
              if (actions.refresh) {
                savedModuleRefetch()
                actions.setRefresh(false)
              }
              return (
                <>
                  {!!hasSavedOrders &&
                    <MobileView>
                      <ModuleMenuBar
                        moduleRefetch={savedModuleRefetch}
                        changeDisplayMenu={changeDisplayMenu}
                        displayMenu={displayMenu}
                        menuButtonRef={menuButtonRef}
                      />
                    </MobileView>
                  }
                  {hasSavedOrders ?
                    savedModuleData.savedOrdersMobile.sort((a, b) => {
                      const firstDate = moment(a.DateSaved);
                      const secondDate = moment(b.DateSaved);
                      if (firstDate.isAfter(secondDate)) {
                        return -1;
                      } else if (secondDate.isAfter(firstDate)) {
                        return 1;
                      } else {
                        return 0;
                      }
                    }).map((item, index) => {
                      const itemId = item.OrderNo + '_' + index;
                      item.DateShip = moment(item.DateShip, 'YYMMDD');
                      setOrdersIds(value => {
                        if (!value.includes(itemId)) {
                          const arr = [...value]
                          arr.push(itemId);
                          return arr;
                        }
                        return value;
                      });
                      return (
                        <div key={itemId}>
                          <React.Fragment>
                            <GridApiController
                              data={
                                item.Det
                              }
                              loading={loading || savedModuleLoading}
                              refetching={savedModuleRefetching}
                              refetched={savedModuleRefetch}
                              refetch={refreshContent}
                              defaultColumns={defaultUserSettings.defaultColumns}
                              defaultSorting={defaultUserSettings.defaultSorting}
                              defaultGroupPanels={
                                defaultUserSettings.defaultGroupPanels
                              }
                              paginated={paginated}
                              active={active}
                              forceRefreshAfterUpdate
                              allowRemoval
                              allowAddition
                              {...userSettings}
                            >
                              {({
                                selectedItems,
                                gridUpdated,
                                collection,
                                columnsMapping,
                                currentItem,
                                onGridUpdated,
                                onGridRef,
                                onGridWillUnmount,
                                onColSorted,
                                onColResized,
                                onColDragged,
                                onColFreezed,
                                onRowFreezed,
                                onRowSelected,
                                onColumnsMappingChange,
                                onCurrentItemChanged,
                                onGroupPanelChanged,
                                onClearSelection,
                                onItemAdded,
                                itemAddedStatus,
                                orderCreateStatus,
                                orderRemoveStatus,
                                onOrderRemoved,
                                onOrderCreated,
                                onNotesSaved,
                                onItemUpdated,
                                saveStatus,
                                onViewSaved,
                                onViewReset,
                                grid,
                                userViewState,
                                refetching,
                                hasAllColumnsHidden,
                                frozenColumns,
                                refetch,
                                isLoading,
                                isRefetching,
                                hasDataToDisplay,
                                clearCollectionAndResetChangedOrderItems,
                                playResetAnimation,
                                handleResetAnimation,
                                setFlexGridFilter,
                                clearInternalFilters,
                              }) => {
                                const order = item;
                                const orderCreated = item.Account.AcctNo;

                                return (
                                  <React.Fragment>
                                    <ActionsHeader
                                      grid={grid}
                                      collection={collection}
                                      defaultColumnsMapping={
                                        defaultUserSettings.defaultColumns
                                      }
                                      columnsMapping={columnsMapping}
                                      selectedItems={selectedItems}
                                      moduleName={moduleName}
                                      saveStatus={saveStatus}
                                      loading={isLoading || isRefetching}
                                      onViewSaved={onViewSaved}
                                      onViewReset={onViewReset}
                                      onNotesSaved={onNotesSaved}
                                      onOrderCreated={onOrderCreated}
                                      onColumnsMappingChange={
                                        onColumnsMappingChange
                                      }
                                      onClearSelection={onClearSelection}
                                      onOrderRemoved={onOrderRemoved}
                                      userViewState={userViewState}
                                      refetch={refetch}
                                      hasAllColumnsHidden={hasAllColumnsHidden}
                                      hasDataToDisplay={hasDataToDisplay}
                                      frozenColumns={frozenColumns}
                                      currentItem={currentItem}
                                      onItemAdded={onItemAdded}
                                      itemAddedStatus={itemAddedStatus}
                                      defaultSettings={defaultUserSettings}
                                      handleResetAnimation={handleResetAnimation}
                                      useLegacyColumnsManager={true}
                                    >
                                      {(actions) => {
                                        return (
                                          <div ref={menuRefs && menuRefs[itemId]}>
                                            <Row
                                              css={{
                                                justifyContent: 'space-between',
                                                padding: '0 10px',
                                                ...(isMobile && {
                                                  position: 'absolute',
                                                  bottom: 0,
                                                  boxShadow:
                                                    '0px -4px 4px 0px #ACACAC40',
                                                  zIndex: 100,
                                                  background: '#fff',
                                                  borderRadius: '8px 8px 0px 0px',
                                                  width: '100%',
                                                  display: displayMenu || displayRowMenu[itemId]
                                                    ? 'flex'
                                                    : 'none',
                                                  justifyContent: 'center',
                                                  height: displayRowMenu[itemId] && '150px' || displayMenu && '100px',
                                                }),
                                              }}
                                            >
                                              <Col css={{ width: '100%' }}>
                                                <ActionsOrganizer
                                                  minHeight='80px'
                                                  onItemUpdated={onItemUpdated}
                                                  ShipTo={
                                                    item &&
                                                    item.ShipTo
                                                  }
                                                  Det={
                                                    item &&
                                                    item.Det
                                                  }
                                                  collection={collection}
                                                  {...actions}
                                                  refetch={savedModuleRefetch}
                                                  moduleRefetch={() => { }}
                                                  clearInternalFilters={
                                                    clearInternalFilters
                                                  }
                                                  setItemHistory={setItemHistory}
                                                  displayRowMenu={displayRowMenu[itemId]}
                                                  displayMenu={displayMenu}
                                                  currentItem={item}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        )
                                      }}
                                    </ActionsHeader>
                                    {isMobile && !orderCreated && !isLoading && (
                                      <div className="order-empty-container">
                                        <div className="order-empty">
                                          <div className="empty-title">
                                            No saved orders
                                          </div>
                                          <div className="empty-message">
                                            Go to Accounts page to start creating
                                            order
                                          </div>
                                          <button
                                            className="empty-button"
                                            onClick={() =>
                                              history.push('/accounts')
                                            }
                                          >
                                            Go To Accounts
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                    <ContentChecker
                                      isLoading={isLoading}
                                      isRefetching={isRefetching}
                                      hasAllColumnsHidden={hasAllColumnsHidden}
                                      hasDataToDisplay={hasDataToDisplay}
                                      collection={collection}
                                      noContentMsg={messages.order.noContent}
                                    >
                                      {() => {
                                        const gridApi = (
                                          <GridApi
                                            active={active}
                                            collection={collection}
                                            columnsMapping={columnsMapping}
                                            frozenColumns={frozenColumns}
                                            onRowSelected={onRowSelected}
                                            onColSorted={onColSorted}
                                            onColResized={onColResized}
                                            onColDragged={onColDragged}
                                            onColFreezed={onColFreezed}
                                            onRowFreezed={onRowFreezed}
                                            onGridUpdated={onGridUpdated}
                                            onGridWillUnmount={onGridWillUnmount}
                                            onCurrentItemChanged={
                                              onCurrentItemChanged
                                            }
                                            onGroupPanelChanged={
                                              onGroupPanelChanged
                                            }
                                            onClearSelection={onClearSelection}
                                            ref={onGridRef}
                                            refetching={isRefetching}
                                            hasAllColumnsHidden={
                                              hasAllColumnsHidden
                                            }
                                            hasDataToDisplay={hasDataToDisplay}
                                            isFullPage={isFullPage}
                                            showFrozenBars
                                            showGroupPanel={showGroupPanel}
                                            paginated={paginated}
                                            formatters={formatters}
                                            addGrandTotalRow
                                            grandTotalRowCustomContent={
                                              grandTotalRowCustomContent
                                            }
                                            playResetAnimation={playResetAnimation}
                                            setFlexGridFilter={setFlexGridFilter}
                                            gridHeight={isMobile && '113px'}
                                            isMobile={isMobile}
                                          // TODO: In case we need to add aggregateTotal from GridApi to the saved Orders 
                                          // setAggregateTotal={setAggregateTotalFun}
                                          // aggregateTotal={aggregateTotal}
                                          // itemId={itemId}
                                          />
                                        )
                                        const activeOrderAccount = item.Account;
                                        // TODO: In case we need to add aggregateTotal from GridApi to the saved Orders 
                                        // const orderTotal = aggregateTotal[itemId];

                                        return isMobile ? (
                                          orderCreated &&
                                          <div className="order-details-container">
                                            <div className="order-details-header">
                                              <p>{activeOrderAccount && item.Account.AcctName}</p>
                                              <img
                                                ref={orderButtonRefs && orderButtonRefs[itemId]}
                                                src='assets/3dots.svg'
                                                onClick={() => {
                                                  changeDisplayRowMenu(!displayRowMenu[itemId], itemId);
                                                }}
                                              />
                                            </div>
                                            <div className="order-details-content">
                                              <p>Type: {activeOrderAccount && item.OrderTypeFull}</p>
                                              <p>Account #: {activeOrderAccount && order.Account.AcctNo}</p>
                                              <p>Account Address: {activeOrderAccount && item.Account.Address}</p>
                                              {item.OrderDate && <p>Ship Date: {moment(item.OrderDate, 'YYMMDD').format('L')}</p>}
                                              {item.DateSaved && <p>Date Saved: {moment(item.DateSaved).format('L')}</p>}
                                              {hasDataToDisplay && <p>Order Details:</p>}
                                            </div>
                                            {hasDataToDisplay && gridApi}
                                            {hasDataToDisplay &&
                                              <div className="order-details-bottom">
                                                <p>Total: </p>
                                                <p
                                                  style={{
                                                    color: colors.mobileGreen,
                                                  }}
                                                >
                                                  ${item.Total.toFixed(2)}
                                                </p>
                                              </div>}
                                          </div>
                                        ) : (
                                          <React.Fragment>
                                            <Curtain
                                              container={grid && grid.hostElement}
                                              active={active}
                                            />
                                            {gridApi}
                                          </React.Fragment>
                                        )
                                      }}
                                    </ContentChecker>
                                  </React.Fragment>
                                )
                              }}
                            </GridApiController>
                          </React.Fragment>
                        </div>
                      )
                    }) : (
                      <div className="order-empty-container">
                        <div className="order-empty">
                          <div className="empty-title">
                            No saved orders
                          </div>
                          <div className="empty-message">
                            Go to Accounts page to start creating
                            order
                          </div>
                          <button
                            className="empty-button"
                            onClick={() =>
                              history.push('/accounts')
                            }
                          >
                            Go To Accounts
                          </button>
                        </div>
                      </div>
                    )}
                </>
              )
            }}
          </Query>
        )}
      </ModuleQuery>
    </div>
  )
}

export default App
